import React, { useEffect, useState } from 'react';
import classes from "./IntroPage.module.css";
import { useNavigate } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { upcomingMatchesPublicApi } from '../http/http';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import SmallLoader from '../component/SmallLoader';
import Container from '../component/Container';
import MatchLayout from '../component/MatchLayouts/MatchLayout';
import { toast } from 'react-toastify';

const IntroPage = () => {
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [userMatches, setUserMatches] = useState(null);
    const [loader, setLoader] = useState(true);
    const dispatch = useDispatch();
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    const fetchUpcomingMatches = async (load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await upcomingMatchesPublicApi();
            setUpcomingMatches(response?.data);
            console.log(response, 'response...');
            setLoading(false);
            setLoader(false);


        }
        catch (error) {
            setLoading(false);
            setLoader(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }

    useEffect(() => {
         if (!userDetails?.token) {
            fetchUpcomingMatches(true);
         }
         else{
            navigate("/home");
         }
    }, []);
/*
    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchUpcomingMatches();
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, []);
    */

    return (
        <Layout>
            <SubLayout>
                <Header hide={true} />
                {loading ?
                    <SmallLoader /> : (
                        <>
                            <Container>
                                <div className={classes.upcoming_matches_container}>
                                    {upcomingMatches.length > 0 &&
                                        upcomingMatches.map((match, index) => {
                                            return (
                                                <MatchLayout match={match} key={index} fantasy_match_joined={userMatches?.fantasy?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                                    prediction_match_joined={userMatches?.prediction?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                                    redirectToSubscribe={true}
                                                />
                                            )
                                        }
                                        )}
                                </div>
                            </Container>
                        </>
                    )
                }

            </SubLayout>
        </Layout>
    )
}

export default IntroPage